module.exports = __webpack_public_path__ + "static/img/1.76271ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/1.png
// module id = liVb
// module chunks = 0